import PickupCardActivator from '@/api/pickup-card-activator'
import StudentProfile from '@/api/student-profile'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  students: [],
  cardStatus: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_STUDENTS(state, data) {
    state.students = data
  },
  SET_CARD_STATUS(state, data) {
    state.cardStatus = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return PickupCardActivator.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return PickupCardActivator.store(data)
  },

  update(context, { id, ...data }) {
    return PickupCardActivator.update(id, data)
  },

  change(context, data) {
    return PickupCardActivator.change(data)
  },

  async checkCurrentStudentCardStatus(context, data) {
    return await PickupCardActivator.checkCurrentStudentCardStatus(data)
  },

  fetchStudents(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        setup_student_profiles:
          'student_id,first_name_en,last_name_en,first_name_kh,last_name_kh,card_number,gender'
      },
      ...attributes
    }

    return StudentProfile.get({ params }).then(response => {
      context.commit('SET_STUDENTS', response.data)
      return Promise.resolve(response)
    })
  },
  async dataBeforeCreate(context) {
    if (!context.state.cardStatus.length > 0) {
      let response = await PickupCardActivator.getCardStatus()
      context.commit('SET_CARD_STATUS', response)
    }
  }
}
